import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "export-your-report",
  courseId: "getting-started",
  order: 5,
  title: "Export your report",
  subtitle: "PDF, Word, email, copy",
  summary:
    "Most officers paste the narrative into their RMS with **Copy to Clipboard**. PDF, Word, and email cover attachments and supervisors, and the transcript exports separately.",
  learn: [
    "Pick the right export for where the report is going",
    "Set the PDF options: title, case ID, dates, header and footer",
    "Export the transcription separately when you need it",
  ],
  minutes: 3,
  sceneId: "export-your-report",
  tourId: "export-your-report",
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "Where the report is going decides the export. **Copy to Clipboard** is the fastest path into a records system. **PDF Document** and **Word Document** are for attachments and supervisors, and **E-mail** sends the report directly.",
    },
    {
      type: "steps",
      items: [
        "Open the case and click **Export** at the right end of the editor toolbar.",
        "Choose **Copy to Clipboard** to paste into your RMS.",
        "Choose **PDF Document** to open the \"Export to PDF\" dialog, set the options, and click **Agree and download PDF**.",
        "Choose **Word Document** for a .docx with the same content.",
        "Choose **E-mail** to open \"Send Email\", enter the recipient, and click **Agree and send email**.",
        "Choose **Transcription** to download the transcript as DOCX or TXT, with **Include Timestamps** and a **Header** option, then click **Download file**.",
      ],
    },
    {
      type: "paragraph",
      text: "Clipboard formatting is preserved where the destination supports it. The PDF dialog offers Include Title, Title, Include Case ID, Include Date, Include Generated Date & Time, Page Header, Page Footer, and Preserve Formatting. **Transcription** appears only when the case has a transcript.",
    },
    {
      type: "callout",
      tone: "note",
      title: "Export with redactions",
      text: "Every export dialog has \"Export with redactions\". When it is on, redacted text is replaced with bars, with optional \"Show tags on bars\" and \"Legal justification footnotes\". Leave it off for the internal copy.",
    },
    {
      type: "callout",
      tone: "warning",
      title: "Delete case upon export",
      text: "Some departments set a retention policy that moves or deletes the case when you export. If \"Delete case upon export\" is checked, that is your agency's setting. Confirm the export succeeded before you close the tab.",
    },
    {
      type: "paragraph",
      text: "If your department has form templates, the Export menu also shows **Fill Forms**, which fills a PDF form from this case. The Forms and files course covers it. Before any of these exports, clear leftover placeholders (see Review the draft).",
    },
  ],
  related: ["review-the-draft", "redact-a-pdf", "fill-a-form-from-audio"],
};

export default lesson;
